import axios, {AxiosResponse} from 'axios';
import {INotificationsResponse, IGetNotificationsParams} from '../notifications/interfaces';

export const getNotificationsApi = (params: IGetNotificationsParams): Promise<AxiosResponse<INotificationsResponse>> => {
  return axios.get(`${process.env.REACT_APP_API_URL}/activity/notifications`, {
    params: {
      limit: params.limit,
      offset: params.offset,
      ind_read: params.indRead
    }
  });
};

export const markNotificationReadApi = (notifId: number): Promise<AxiosResponse<void>> => {
  return axios.post(`${process.env.REACT_APP_API_URL}/activity/notification/read`, notifId);
};

export const getNotificationCountApi = (): Promise<AxiosResponse<{value: number}>> => {
  return axios.get(`${process.env.REACT_APP_API_URL}/activity/notifications/unread-count`);
};

export const markAllNotificationsReadApi = (): Promise<AxiosResponse<void>> => {
  return axios.post(`${process.env.REACT_APP_API_URL}/activity/notification/read-all`);
};
